import React from "react";

const msViewerLink = (url, docType) => {
  const encodedUrl = encodeURIComponent(url);

  switch (docType) {
    case "application/msword":
      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`;
    case "application/vnd.ms-excel":
      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`;
    case "application/vnd.ms-powerpoint":
      return `https://view.officeapps.live.com/op/embed.aspx?src=${encodedUrl}`;
    default:
      return url;
  }
};

const MSViewer = ({ url, docType, handleLoad, handleError }) => {
  return (
    <div className="card shadow-sm">
      <div className="card-body p-0">
        <iframe
          src={msViewerLink(url, docType)}
          title="Document Viewer"
          className="w-100"
          style={{
            height: "600px",
            border: "none",
          }}
          onLoad={handleLoad}
          onError={handleError}
        />
      </div>
    </div>
  );
};

export default MSViewer;
